import { TranslateLoader } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import * as portugueseFile from "./translations_pt-br.json";
import * as englishFile from "./translations_en-us.json";

interface Translations {
  [key: string]: string;
}

export class LexTranslateLoader implements TranslateLoader {
  constructor() {}

  getTranslation(lang: string): Observable<any> {
    const portugueseLanguage = portugueseFile as Translations;
    const englishLanguage = englishFile as Translations;

    if (!lang.includes("pt-br")) {
      return of(englishLanguage.default);
    }
    return of(portugueseLanguage.default);
  }
}
